import { render, staticRenderFns } from "./Normativa.vue?vue&type=template&id=506a3ff3&scoped=true"
import script from "./Normativa.vue?vue&type=script&lang=js"
export * from "./Normativa.vue?vue&type=script&lang=js"
import style0 from "./Normativa.vue?vue&type=style&index=0&id=506a3ff3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506a3ff3",
  null
  
)

export default component.exports